import DeleteGenericModal from "../../modals/DeleteGenericModal";
import ReactTable from "../../util/ReactTable";
import AsyncBlock from "../../components/forms/AsyncBlock";
import PageTitle from "../../components/layout/PageTitle";
import PageSection from "../../components/layout/PageSection";
import Button from "../../components/forms/Button";
import PageContainerFull from "../../components/layout/PageContainerFull";
import {useCallback, useMemo} from "react";
import {FlexLayout} from "../../components/flex/Flex";
import useDeleteModal from "../../modals/useDeleteModal";
import axios from "axios";
import useFetch2 from "../../hooks/useFetch2";
import {Apis} from "../../util/data";
import {useNavigate} from "react-router-dom";
import {format} from "date-fns";

const ClientList = () => {

  const navigate = useNavigate()
  const {loading, data, fetchData, error} = useFetch2(Apis.PROD + '/usuario/list/clientes', []);

  const deleteElement = id => axios.delete(Apis.PROD + '/usuario/' + id)

  const formatoFecha = 'dd/MM/yyyy';

  const {
    wrapper: wrapper1,
    openDeleteModal
  } = useDeleteModal({
    text: '¿Desea eliminar este cliente?',
    action: deleteElement,
    onRefresh: fetchData
  })

  function addUser() {
    navigate('/clientes/new')
  }

  function editUser(item) {
    navigate('/clientes/edit/' + item.id)
  }

  const nameValue = useCallback(cell => cell.renderValue() + ' ' + cell.row.original.apellidos, []);

  const fechaValue = useCallback(cell => {
    const fechaUTC = new Date(cell.renderValue() + new Date().getTimezoneOffset() * 60000);
    return format(fechaUTC, formatoFecha)
  }, []);
  const actionsValue = useCallback(cell =>
      <FlexLayout justifyContent='center'>
        <Button size='xs' variant='light' onClick={() => editUser(cell.row.original)}>Editar</Button>
        <Button size='xs' variant='danger' onClick={() => openDeleteModal(cell.row.original.id)}>Eliminar</Button>
      </FlexLayout>
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , []);

  const columns = useMemo(
    () => [
      {
        header: 'Nombre',
        id: 'nombres',
        accessorFn: cell => `${cell.nombres} ${cell.apellidos}`,
        cell: nameValue
      },
      {
        header: 'Celular',
        accessorKey: 'nroCelular',
      },
      {
        header: 'Email',
        accessorKey: 'email',
      },
      {
        header: 'Sexo',
        accessorKey: 'sexo',
      },
      {
        header: 'Nacimiento',
        accessorKey: 'fechaNacimiento',
        cell: fechaValue
      },
      {
        header: 'Registro',
        accessorKey: 'fechaRegistro',
        cell: fechaValue
      },
      {
        header: 'Acciones',
        accessorKey: 'id',
        meta: {
          headerClassName: 'text-center', // class para la cabecera
          columnClassName: 'text-center', // class para la columna
        },
        enableSorting: false, // para deshabilitar el sort
        cell: actionsValue
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    , [data]
  )

  return (
    <PageContainerFull>

      <PageSection>
        <PageTitle title={'Clientes'}/>

        <AsyncBlock loading={loading} error={error}>
          <ReactTable
            columns={columns}
            data={data || []}
            customSearch
            filterAdd={() => addUser()}
            noData='No existen clientes registrados'
            pageSize={20}
          />
        </AsyncBlock>
      </PageSection>
      <DeleteGenericModal {...wrapper1} />
    </PageContainerFull>
  )
}

export default ClientList
